import {
  DateDomain,
  Domain,
  DomainName,
  EnumDomain,
  EnumValue,
  FloatDomain,
  NumberDomain,
  ObjectDomain,
  StringDomain,
  TDomainSubType,
  TDomainType,
  tg,
} from '@infotech-soe/metaschema';

export class NamedDomain {
  public type: TDomainType;
  public class?: ObjectDomain['class'];
  public values?: EnumValue[];
  public format?: string;
  public decorator?: string;
  public length?: StringDomain['length'];
  public lengthInBytes?: StringDomain['lengthInBytes'];
  public subtype?: TDomainSubType;
  public precision?: FloatDomain['precision'];
  public align?: StringDomain['align'];
  public min?: NumberDomain['min'];
  public max?: NumberDomain['max'];
  public regExp?: StringDomain['regExp'];

  constructor(
    public name: DomainName,
    domain: Domain
  ) {
    this.type = domain.type;
    if ((domain as ObjectDomain).class) {
      this.class = (domain as ObjectDomain).class;
    }
    if ((domain as EnumDomain).values) {
      this.values = (domain as EnumDomain).values;
    }
    if (this.class === 'Date') {
      this.format = (domain as DateDomain).format;
    }
    if (domain.constructor.name !== 'Object') {
      this.decorator = domain.constructor.name;
    }
    if (tg.isNumber((domain as StringDomain).length)) {
      this.length = (domain as StringDomain).length;
    }
    if (tg.isBoolean((domain as StringDomain).lengthInBytes)) {
      this.lengthInBytes = (domain as StringDomain).lengthInBytes;
    }
    if (tg.isString((domain as StringDomain).regExp)) {
      this.regExp = (domain as StringDomain).regExp;
    }
    if ((domain as NumberDomain).subtype) {
      this.subtype = (domain as NumberDomain).subtype;
    }
    if (tg.isNumber((domain as FloatDomain).precision)) {
      this.precision = (domain as FloatDomain).precision;
    }
    if ((domain as StringDomain).align) {
      this.align = (domain as StringDomain).align;
    }
    if (tg.isNumber((domain as NumberDomain).min)) {
      this.min = (domain as NumberDomain).min;
    }
    if (tg.isNumber((domain as NumberDomain).max)) {
      this.max = (domain as NumberDomain).max;
    }
  }
}
